<template>

<div>

	<v-menu v-if="type === 'menu'" offset-y dense>
		<template v-slot:activator="{ on }">
			<v-btn tile block v-on="on">
				{{ $t('compOrdersByTokenPair.popularTradingPairs') }}
				<v-icon>mdi-chevron-down</v-icon>
			</v-btn>
		</template>
		<v-list dense class="overflow-y-auto" max-height="300">
			<v-list-item
				v-for="option in tokenPairOptions" :key="option.text"
				:to="{ name: 'OrdersByTokenPair', params: option.value} "
			>
				<v-list-item-title>{{ option.text }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>

	<div v-if="type === 'chip'">
		<v-chip v-for="option in tokenPairOptions" :key="option.text"
      :to="{ name: 'OrdersByTokenPair', params: option.value} "
      class="mr-2 mb-1" color="primary"
    >
    	{{ option.text }}
    </v-chip>
	</div>

</div>

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
	name: 'PopularTradingPairList',
	props: {
    type: { type: String, default: "menu" },  // "menu" or "chip"
    doNotSort: { type: Boolean, default: false},
  },
	data () {
		return {
			tokenPairOptions: [],
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			myAddress: 'getUserAccount',
			tokenInfo: 'getTokenInfo',
			relayerList: 'getRelayerList',
			relayerInfo: 'getRelayerInfo',
			networkConfig: 'getNetworkConfig',
		}),
	},
	methods: {
		async init () {
			this.loadTokenPairOptions()
		},
		loadTokenPairOptions () {
			this.tokenPairOptions = []
			const tokenPairList = [ ...this.tokenInfo.popularTradingPairList ]
			if (!this.doNotSort) {
				tokenPairList.sort((a,b) => {
					return a.tokenA.symbol > b.tokenA.symbol ? 1 : a.tokenA.symbol < b.tokenA.symbol ? -1 : 0;
				})
			}
			for (let tokenPair of tokenPairList) {
				const routerParams = {
						makerAssetSymbol: tokenPair.tokenA.symbol,
						takerAssetSymbol: tokenPair.tokenB.symbol,
						makerAssetAddress: tokenPair.tokenA.address,
						takerAssetAddress: tokenPair.tokenB.address
				}
				const option = {
					value: routerParams,
					text: `${tokenPair.tokenA.symbol} - ${tokenPair.tokenB.symbol}`,
				}
				this.tokenPairOptions.push(option)
			}
		},
	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
